module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-09.fecc99b0.png";